<template>
    <div id="app"
         v-loading.fullscreen.lock="$root.loading"
         element-loading-text="Loading..."
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.1)">
        <router-view/>
        <el-dialog title="上传附件"
                   width="50%"
                   top="10vh"
                   :visible.sync="uploadFileDialog"
                   :close-on-click-modal="$root.dialogAutoClose"
                   :close-on-press-escape="$root.dialogAutoClose">
            <div style="overflow-y: auto;margin-top: -35px;padding: 15px 0;max-height: 400px;">
                <el-form :model="dialogForFile" label-width="150px">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="选择附件：" required class="noMarginBottom">
                                <el-upload  :action="$root.uploadUrl"
                                            :show-file-list="false"
                                            :multiple="false"
                                            :before-upload="beforeFileUpload"
                                            :on-progress="fileListHandleProgress"
                                            :on-success="fileListHandleSuccess"
                                            :on-error="fileListHandleError">
                                    <el-button size="mini" type="primary"
                                               :loading="fileListLoading"
                                               :disabled="fileListDisabled">
                                        {{(fileListLoading)?'上传中...':'点击上传'}}
                                    </el-button>
                                    <p class="tips">提示：附件大小限制500M</p>
                                </el-upload>
                                <div class="file-list">
                                    <div v-for="(file,index) in dialogForFile.fileList" :key="index" class="file-item clearfix">
                                        <div class="file-name">
                                            <a href="javascript:;" title="点击下载"  @click="fileListHandleDownload(file)"><span><i class="el-icon-document"></i>{{file.attachName}}</span></a>
                                        </div>
                                        <div class="file-button">
                                            <el-button type="default" size="mini" @click="fileListHandleRemove(index)">删除</el-button>
                                        </div>
                                    </div>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="附件描述：" class="noMarginBottom" v-if="uploadFileDialogRemark">
                                <el-input type="textarea"
                                        :maxlength="500" v-model="dialogForFile.remarks"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="default" @click="uploadFileDialogRemark = true;uploadFileDialog = false;dialogForFile.fileList = [];" size="mini">取 消</el-button>
                <el-button type="primary" @click="uploadFileSubmit" size="mini">提 交</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

    export default {
        name: 'App',
        data() {
            return{
                /*附件上传 start*/
                uploadFileDialog: false,
                uploadFileDialogRemark: true,
                receiveFiledName:'',
                dialogForFile:{
                    fileList:[],
                    remarks:'',
                },
                fileListLoading: false,
                fileListDisabled: false,
                /*附件上传 end*/
            }
        },
        components: {

        },
        mounted(){
            window.myAppObj = this;
        },
        methods: {
            /*附件上传 start*/
            beforeFileUpload(file){
                const isLt500M = file.size / 1024 / 1024 < 500;
                if (!isLt500M) {
                    this.$message.error('上传附件大小不能超过 500MB!');
                    return false;
                }
            },
            fileListHandleProgress(){
                this.fileListLoading = true;
                this.fileListDisabled = true;
            },
            fileListHandleSuccess(response){
                let that = this;
                that.fileListLoading = false;
                that.fileListDisabled = false;
                if(response.code == 1){
                    that.$alert('上传成功',{
                        type: 'success'
                    });
                    that.dialogForFile.fileList = response.data || [];
                }else{
                    that.$alert('上传失败',{
                        type: 'error'
                    })
                }
            },
            fileListHandleError(){
                let that = this;
                that.$alert('上传失败',{
                    type: 'error'
                });
                that.fileListLoading = false;
                that.fileListDisabled = false;
            },
            fileListHandleRemove(index){
                let that = this;
                that.$confirm('确定删除该附件吗?',{
                    type:'warning',
                    callback:(action)=>{
                        if(action == 'confirm'){
                            that.dialogForFile.fileList.splice(index,1);
                        }
                    }
                });
            },
            fileListHandleDownload(file){
                let that = this;
                that.$confirm('确定下载该附件吗?',{
                    type:'warning',
                    callback:(action)=>{
                        if(action == 'confirm'){
                            that.$root.downloadFile({
                                attachName: file.attachName,
                                attachPath: file.attachPath
                            })
                        }
                    }
                });
            },
            uploadFileSubmit(){
                let that = this;
                if(that.dialogForFile.fileList.length == 0){
                    that.$alert('请上传文件',{
                        type: 'warning'
                    })
                }else{
                    let pageObj = {
                        /*质疑*/
                        questionFiles: {
                            attachmentType: 26,
                            windowName: 'questionObj',
                            pageFields: 'questionFiles'
                        },
                    };
                    let newFileList = [];
                    that.dialogForFile.fileList.forEach(function (item) {
                        item.attachmentType = pageObj[that.receiveFiledName].attachmentType;
                        item.remarks = that.dialogForFile.remarks;
                        newFileList.push(item);
                    });

                    // obj['createByUsername'] = that.$root.currentUserResponseVO.realName;
                    window[pageObj[that.receiveFiledName].windowName][pageObj[that.receiveFiledName].pageFields].push(newFileList[0]);
                    that.uploadFileDialog = false;
                    that.uploadFileDialogRemark = true;
                    that.dialogForFile = {
                        fileList:[],
                        remarks:'',
                    };

                    // that.$root.postHttp('/v1/outerformflowHS/addSAttachment',{
                    //     attachName: newFileList[0].attachName,
                    //     attachPath: newFileList[0].attachPath,
                    //     attachSize: newFileList[0].attachSize,
                    //     attachmentSubType: newFileList[0].attachmentSubType,
                    //     attachmentType: newFileList[0].attachmentType,
                    //     remarks: newFileList[0].remarks,
                    //     formId: that.$route.params.formId,
                    //     relatedId: that.$route.params.formId,
                    // },function (res) {
                    //     if(res.data && res.data.data){
                    //         let obj  = res.data.data;
                    //         obj['createByUsername'] = that.$root.currentUserResponseVO.realName;
                    //         window[pageObj[that.receiveFiledName].windowName][pageObj[that.receiveFiledName].pageFields].push(res.data);
                    //         that.uploadFileDialog = false;
                    //         that.dialogForFile = {
                    //             fileList:[],
                    //             remarks:'',
                    //         };
                    //     }
                    // });
                }
            },
            /*附件上传 end*/
        },
    }
</script>

<style lang="scss">
@import './assets/entry.scss';
html {
    height: 100%;
    overflow: hidden;
}
body {
    height: 100%;
    // overflow: scroll;
    overflow: auto;
}
body,h1,h2,h3,h4,h5,p {
    margin: 0;
}
/*html ,body {
    height: 100%;
}*/
ul,ol {
    margin: 0;
    padding: 0;
    list-style: none;
}
#app /deep/{
  font-family: $--font-family;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $--text-color;
    min-height: 100%;

    /*上传附件dialog样式 start*/
    .file-list{}
    .file-list .file-item{}
    .file-list .file-name{
        float: left;
    }
    .file-list .file-button{
        float: right;
        margin-left: 20px;
    }
    .file-name a{
        text-decoration: underline;
        color: #0091FF;
    }
    .el-upload{
        text-align: left;
    }
    /*上传附件dialog样式 end*/


    .width90{
        width: 90px !important;
    }

    .width100{
        width: 100px !important;
    }
    .el-form-item__label, .el-form-item__content, .el-radio__label {
        font-size: 13px;
    }

    h3.iconfont {
        font-size: 15px!important;
    }



    .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #003670!important;
    }
}

.el-input.is-disabled .el-input__inner{
    color: #333333 !important;
}

.el-textarea.is-disabled .el-textarea__inner{
    color: #333333 !important;
}

.el-radio__input.is-disabled + span.el-radio__label{
    color: #333333 !important;
}
.noscroll{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue